/* eslint-disable */
import { useTranslation } from "react-i18next";

export default function DetailsPrintAgent() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[420px] h-fit dark:!bg-[#181919]">
      <section className="cta-sec relative max-w-screen-xl px-4 md:px-8 h-fit mt-5 pt-0">
        <div className="flex flex-col">
          <h3 className="text-2xl font-bold text-gray-800 dark:!text-gray-200 mb-4">
            {t("servicePageDetails.printAgent.title")}{" "}
            <span className="text-[#9e68ba] dark:!text-[#bc7ade]">
              {t("servicePageDetails.printAgent.highlight")}
            </span>
          </h3>

          <p className="text-gray-600 dark:!text-gray-300 mb-6 leading-relaxed">
            {t("servicePageDetails.printAgent.description")}
          </p>

          <div className="bg-[#fcf6ff] dark:!bg-[#222222] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-4">
            <h4 className="font-medium text-[#9e68ba] dark:!text-[#bc7ade] mb-2">
              {t("servicePageDetails.printAgent.featuresTitle")}
            </h4>

            <ul className="space-y-2 text-gray-700 dark:!text-gray-300">
              {[1, 2, 3, 4, 5].map((num) => (
                <li key={num} className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t(`servicePageDetails.printAgent.features.feature${num}`)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}